<template>
  <div ref="login" class="login" >
    <div class="blur">
      <img src="../../assets/slide-1.jpg" style="width:100%;height:100%;">
    </div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-position="left" label-width="0px" class="login-form">
      <h3 class="title">
        桓仁红色教育服务中心后台管理系统
      </h3>
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="账号">

        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="loginForm.password" type="password" auto-complete="off" placeholder="密码">

        </el-input>
      </el-form-item>

      <el-form-item style="width:100%;">
        <el-button :loading="loading" size="medium" type="danger" style="width:100%;" @click="login">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--  底部  -->

  </div>
</template>

<script>

import {request} from "@/request/request";

export default {
  name: "LoginAdmin",
  data(){
    return {
      loginForm: {
        username: '',
        password: '',
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', message: '用户名不能为空' }],
        password: [{ required: true, trigger: 'blur', message: '密码不能为空' }]
      },
      loading: false,
    }
  },
  methods:{
    login:function(){
      const user = {
        username: this.loginForm.username,
        password: this.loginForm.password,
      }
      if(user.username==''| user.password==''){
        alert("用户名或密码不能为空");
        return false
      }
      this.loading = true;
      request({
        method:'POST',
        url:'/users/login',
        data:user,
      }).then(res =>{
        if(res.code == 1){
          localStorage.setItem('userInfo',JSON.stringify(res.data));
          this.$router.replace({
            path:'/admin/hsjy/admin'
          })
          this.loading = false;
        }
        else{
          alert(res.msg);
          this.loginForm.username = '';
          this.loginForm.password = '';
          this.loading = false;
        }
      },err=>{
        console.log(err)
      })
    }


  },
  mounted() {
    this.$refs.login.style = 'height:'+ window.innerHeight + 'px';
  }
}


</script>

<style scoped >
.login {
  display: flex;
  width:100%;
  justify-content: center;
  align-items: center;

}
.title {
  margin: 0 auto 30px auto;
  text-align: center;
  color:#9E1A28;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 385px;
  padding: 25px 25px 5px 25px;
  position: absolute;

}
.blur{
  height:100%;
  width:100%;
  position: absolute;
  filter: blur(20px);
}
</style>
